export default "__VITE_ASSET__DYDK3NCg__"